import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { PageFAQ } from '@/components/PageFAQ';
import { RelatedPages } from '@/components/RelatedPages';
import { SEO, OrganizationStructuredData, WebSiteStructuredData, LocalBusinessStructuredData } from '@/components/SEO';
import { useTheme } from '@/context/ThemeContext';
import { ClientSuccessStories } from '@/components/ClientSuccessStories';
import { TrustBannerPopup } from '@/components/TrustBannerPopup';

import {
  PremiumHeader,
  HeroSection,
  ValuePropositionsCompact,
  SEOContent,
  FinalCTA,
  PremiumFooter,
  CategoriesGrid,
  ClientLogosMarquee,
  InstagramReelsSection,
} from '@/components/premium';

export default function HomePremium() {
  const navigate = useNavigate();
  const { setHomepageTheme, THEMES } = useTheme();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Manrope, sans-serif' }}>
      {/* Marquee Animation Styles */}
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 25s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>

      <SEO 
        title="Premium Office Furniture | Corporate Workstations & Privacy Booths | Mumbai"
        description="India's trusted B2B office furniture supplier since 2014. Premium modular workstations, privacy booths & storage solutions. Factory direct pricing. Pan-India delivery."
        keywords="corporate office furniture, B2B office furniture india, modular workstations mumbai, office privacy booths, bulk office furniture"
        canonical="/home-premium"
      />
      <OrganizationStructuredData />
      <WebSiteStructuredData />
      <LocalBusinessStructuredData />
      
      {/* Header */}
      <PremiumHeader 
        mobileMenuOpen={mobileMenuOpen} 
        setMobileMenuOpen={setMobileMenuOpen} 
      />

      {/* Trust Side Banner */}
      <TrustBannerPopup />

      {/* Hero Section — 2 CTAs only */}
      <HeroSection />

      {/* Client Logos Marquee */}
      <ClientLogosMarquee />

      {/* Brand Legacy Statement — CTA to Legacy Page */}
      <Link to="/legacy" className="block py-6 sm:py-8 bg-white text-center hover:bg-[#F8F6F1] transition-colors cursor-pointer group" data-testid="legacy-cta-homepage">
        <p className="text-[#2E7D32] text-lg sm:text-xl md:text-2xl font-bold tracking-wide group-hover:text-[#1B5E20] transition-colors" >
          <span className="text-2xl sm:text-3xl md:text-4xl">"MFS"</span>{' '}
          <span className="font-medium">from the house of</span>{' '}
          Ezeefit Modular Furniture Pvt. Ltd.
        </p>
        <p className="text-[#2E7D32] text-sm sm:text-base md:text-lg font-medium tracking-[0.15em] mt-1 group-hover:text-[#1B5E20] transition-colors">
          — A Legacy Since 2014
        </p>
      </Link>

      {/* Categories Grid — Product Showcase */}
      <CategoriesGrid />

      {/* Value Propositions */}
      <div className="bg-[#F8F6F1]">
        <ValuePropositionsCompact />
      </div>

      {/* Client Success Stories */}
      <ClientSuccessStories />

      {/* SEO Content (hidden/accordion, good for SEO) */}
      <SEOContent />

      {/* Instagram Reels */}
      <InstagramReelsSection />

      {/* FAQ + Interlinks */}
      <div className="container mx-auto px-4 sm:px-8 py-12">
        <PageFAQ pageKey="home" />
        <RelatedPages pageKey="home" className="mt-12" />
      </div>

      {/* Final CTA */}
      <FinalCTA />

      {/* Footer */}
      <PremiumFooter />
    </div>
  );
}
